import * as React from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { checkEmailIsDuplicated } from '../../api/constlink';
import PasswordValidator from 'password-validator';
import Title from 'antd/lib/typography/Title';

interface JoinMemberStep1Props {
  onSuccess: (data: any) => void;
}

function JoinMemberStep1({ onSuccess }: JoinMemberStep1Props) {
  const [form] = Form.useForm();
  const _checkEmailIsDuplicated = async (email: string) => {
    const res = await checkEmailIsDuplicated({
      data: {
        email,
      },
    });
    if (res.isDuplicate) return Promise.reject('중복된 이메일이 존재 합니다.');
    else return Promise.resolve();
  };

  const validatePassword = (value: string) => {
    const schema = new PasswordValidator();
    schema
      .is()
      .min(8)
      .is()
      .max(20)
      .has()
      .uppercase()
      .has()
      .lowercase()
      .has()
      .digits(1)
      .has()
      .not()
      .spaces();

    if (!value) {
      return Promise.reject(new Error('비밀번호는 필수 항목입니다.'));
    }

    if (!schema.validate(value)) {
      return Promise.reject(
        new Error(
          // '영문 대 소문자, 숫자, 특수문자를 조합한 8자 이상이어야 합니다.',
          '영문 대 소문자, 숫자를 조합한 8자 이상이어야 합니다.',
        ),
      );
    }
    return Promise.resolve();
  };

  const validatePassword2 = (value: string) => {
    if (
      form.getFieldValue('password') &&
      form.getFieldValue('password') !== value
    ) {
      return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
    }
    return Promise.resolve();
  };

  return (
    <>
      <Row justify={'center'} style={{ marginTop: '10px' }}>
        <Col>
          <Title level={4}>하이공사에 로그인할 계정을 만들어 주세요.</Title>
        </Col>
      </Row>
      <Form
        name="basic"
        form={form}
        layout="vertical"
        initialValues={{}}
        onFinish={onSuccess}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="name"
              label="이름"
              rules={[
                {
                  required: true,
                  message: '이름을 입력 하세요.',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="email"
              label="이메일"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '이메일을 입력 하세요.',
                },
                {
                  type: 'email',
                  message: '이메일 입력이 잘못 되었습니다.',
                },
                {
                  validator: (_, value) => _checkEmailIsDuplicated(value),
                },
              ]}
            >
              <Input type="email" placeholder="이메일" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="password"
              label="비밀번호"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
                {
                  validator: (_, value) => validatePassword(value),
                },
              ]}
            >
              <Input.Password placeholder="새 비밀번호" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="password2"
              label="비밀번호 확인"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
                {
                  validator: (_, value) => validatePassword2(value),
                },
              ]}
            >
              <Input.Password type="password" placeholder="새 비밀번호 확인" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={8}>
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                style={{ width: '100%' }}
                disabled={
                  form.getFieldsError().filter(({ errors }) => errors.length)
                    .length > 0
                }
              >
                다음
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default JoinMemberStep1;
